import Splide from '@splidejs/splide';

(($, Drupal) => {
  const getCarouselItems = ($root) => $root.find(
    '> .gossip-grid__item, > .gossip-wrap .gossip-grid__item',
  );

  /**
   * Bygger markupen som Splide behöver.
   */
  const buildStructure = (element) => {
    const $root = $(element);
    const isWrapped = $root.attr('data-gossip-layout') === 'wrapped';

    if ($root.attr('data-gossip-carousel-structured') === 'true') {
      return;
    }

    const $items = getCarouselItems($root);

    if (!$items.length) {
      return;
    }

    if (isWrapped && !$root.data('gossipOriginalHtml')) {
      $root.data('gossipOriginalHtml', $root.html());
    }

    const $track = $('<div>', {
      class: 'splide__track gossip-carousel__track',
    });

    const $list = $('<div>', {
      class: 'splide__list gossip-carousel__list',
    });

    $items.each((index, item) => {
      $(item).addClass('splide__slide');
      $list.append(item);
    });

    if (isWrapped) {
      $root.children('.gossip-wrap').remove();
    }

    $track.append($list);
    $root.append($track);

    $root.attr('data-gossip-carousel-structured', 'true');
  };

  /**
   * Återställer desktop-markupen efter att Splide har förstörts.
   */
  const restoreStructure = (element, $items) => {
    const $root = $(element);

    $root.children('.splide__track').remove();

    $items.each((index, item) => {
      $(item).removeClass('splide__slide');
      $root.append(item);
    });

    $root.removeAttr('data-gossip-carousel-structured');
  };

  /**
   * Visar eller döljer pilar beroende på aktuell slide.
   */
  const updateArrows = (slider, element) => {
    const $root = $(element);
    const $previousArrow = $root.find('.splide__arrow--prev');
    const $nextArrow = $root.find('.splide__arrow--next');

    if (!$previousArrow.length || !$nextArrow.length) {
      return;
    }

    const endIndex = slider.Components.Controller.getEnd();

    $previousArrow.toggleClass('hidden', slider.index <= 0);
    $nextArrow.toggleClass('hidden', slider.index >= endIndex);
  };

  /**
   * Initierar karusellen för ett gossip-element.
   */
  const initGossipCarousel = (element) => {
    const $root = $(element);
    const mobileQuery = window.matchMedia('(max-width: 768px)');

    let slider = null;

    const getDirectChildren = () => $root.find('> .gossip-wrap, > .gossip-grid__item');

    const clearDesktopHeights = () => {
      getDirectChildren().css('height', '');
    };

    const syncDesktopReelHeights = () => {
      if (mobileQuery.matches) {
        clearDesktopHeights();
        return;
      }

      const $reelItems = $root.find('> .gossip-wrap .gossip-grid__item--gossip-reel, > .gossip-grid__item--gossip-reel');

      if (!$reelItems.length) {
        clearDesktopHeights();
        return;
      }

      const $children = getDirectChildren();

      $children.css('height', '');

      let maxReelHeight = 0;

      $reelItems.each((index, reelItem) => {
        const $reelItem = $(reelItem);
        const $directWrapper = $reelItem.parent('.gossip-wrap');
        const heightSource = $directWrapper.length ? $directWrapper : $reelItem;
        const sourceHeight = Math.ceil(heightSource.outerHeight());

        if (sourceHeight > maxReelHeight) {
          maxReelHeight = sourceHeight;
        }
      });

      if (maxReelHeight > 0) {
        $children.css('height', `${maxReelHeight}px`);
      }
    };

    const scheduleDesktopReelSync = () => {
      window.requestAnimationFrame(syncDesktopReelHeights);
    };

    const mount = () => {
      if (!mobileQuery.matches || slider) {
        return;
      }

      const itemCount = getCarouselItems($root).length;

      /*
       * En ensam komponent behöver inte monteras som karusell.
       */
      if (itemCount <= 1) {
        $root
          .removeClass(
            'splide is-initialized is-active is-carousel-active',
          )
          .addClass('is-single-item');

        return;
      }

      $root.removeClass('is-single-item');

      buildStructure(element);

      /*
       * Lägg endast till .splide när komponenten faktiskt
       * ska monteras som en karusell.
       */
      $root.addClass('splide');

      slider = new Splide(element, {
        type: 'slide',
        perPage: 1,
        perMove: 1,
        drag: true,
        arrows: true,
        pagination: true,
        trimSpace: true,
        rewind: false,
        speed: 600,

        gap: '0.75rem',

        padding: {
          right: '2rem',
        },

        mediaQuery: 'min',

        breakpoints: {
          560: {
            perPage: 2,
          },
        },

        classes: {
          arrows: 'splide__arrows',
          arrow:
            'splide__arrow cards__arrow btn btn--icon-filled',
          prev:
            'splide__arrow--prev cards__arrow--prev btn--icon-chevron-left',
          next:
            'splide__arrow--next cards__arrow--next btn--icon-chevron-right',
          pagination:
            'splide__pagination cards__pagination',
        },
      });

      slider.on('mounted move moved resized updated', () => {
        updateArrows(slider, element);
      });

      slider.mount();

      $root.addClass('is-carousel-active');
    };

    const unmount = () => {
      const isWrapped =
        $root.attr('data-gossip-layout') === 'wrapped';

      if (isWrapped) {
        if (slider) {
          slider.destroy(true);
          slider = null;
        }

        const originalMarkup = $root.data('gossipOriginalHtml');
        if (originalMarkup) {
          $root.html(originalMarkup);
        }

        $root.removeAttr('data-gossip-carousel-structured');
        $root.removeClass(
          [
            'splide',
            'is-initialized',
            'is-active',
            'is-focus-in',
            'is-overflow',
            'is-carousel-active',
            'is-single-item',
          ].join(' '),
        );

        $root.removeAttr('role');
        $root.removeAttr('aria-roledescription');
        $root.removeAttr('aria-label');
        $root.removeAttr('aria-live');
        return;
      }

      /*
       * Plocka först loss originalobjekten från Splides markup.
       * Annars riskerar de att försvinna när track tas bort.
       */
      const $items = $root
        .find('.splide__track .gossip-grid__item')
        .detach();

      if (slider) {
        slider.destroy(true);
        slider = null;
      }

      /*
       * Ta bort Splides track och lägg tillbaka originalobjekten
       * direkt i root-elementet.
       */
      if ($items.length) {
        restoreStructure(element, $items);
      } else {
        /*
         * Säkerhetsfall om komponenten inte hade monterats.
         */
        $root.children('.splide__track').remove();
        $root.removeAttr('data-gossip-carousel-structured');
      }

      $root.removeClass(
        [
          'splide',
          'is-initialized',
          'is-active',
          'is-focus-in',
          'is-overflow',
          'is-carousel-active',
          'is-single-item',
        ].join(' '),
      );

      /*
       * Rensa attribut som Splide kan ha satt på root-elementet.
       */
      $root.removeAttr('role');
      $root.removeAttr('aria-roledescription');
      $root.removeAttr('aria-label');
      $root.removeAttr('aria-live');
    };

    const update = () => {
      if (mobileQuery.matches) {
        mount();
      } else {
        unmount();
      }

      scheduleDesktopReelSync();
    };

    update();

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', update);
    } else {
      mobileQuery.addListener(update);
    }

    window.addEventListener('resize', scheduleDesktopReelSync);

    $root.find('video').each((index, video) => {
      video.addEventListener('loadedmetadata', scheduleDesktopReelSync);
    });

    scheduleDesktopReelSync();
  };

  Drupal.behaviors.mstGossipCarousel = {
    attach: (context) => {
      $('.gossip-carousel', context).each((index, element) => {
        const $element = $(element);

        if (
          $element.attr('data-gossip-carousel-init') === 'true'
        ) {
          return;
        }

        $element.attr(
          'data-gossip-carousel-init',
          'true',
        );

        initGossipCarousel(element);
      });
    },
  };
})(jQuery, Drupal);
